export default __webpack_public_path__ + "static/media/category-13.9bbc4be7.svg";